// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-trigger-details-step h2[data-v-32d83920],.flow-trigger-details-step p[data-v-32d83920]{text-align:center}.flow-trigger-details-step h2[data-v-32d83920]{font-size:18px;font-weight:700;color:#141c20;margin-bottom:5px}.flow-trigger-details-step p[data-v-32d83920]{font-size:14px;font-weight:400;color:#7c8b91;margin-bottom:33px}", ""]);
// Exports
module.exports = exports;
